import React from "react";
import { Outlet } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";

const AdminLayout = () => {
  return (
    <div className="cb-page-shell flex h-screen overflow-hidden">

      {/* Sidebar */}
      <Sidebar />

      {/* Main Area */}
      <div className="flex flex-col flex-1 overflow-hidden">

        {/* Topbar */}
        <Topbar />

        {/* Scrollable Content */}
        <main className="cb-main flex-1 overflow-y-auto px-6 py-6 lg:px-8">
          <Outlet />
        </main>

      </div>

    </div>
  );
};

export default AdminLayout;
